// src/pages/produk/ModulKomponen.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; // <-- TAMBAHKAN INI

// Struktur data untuk konten edukasi
const iotEssentials = [
  {
    category: 'Server & Cloud Platform',
    icon: '☁️', // Ikon emoji sebagai placeholder, bisa diganti dengan SVG
    description: 'Jantung sistem IoT, tempat data dikumpulkan, diproses, dan dianalisis. Server ini bisa berupa platform cloud publik atau server lokal yang Anda kelola sendiri.',
    items: [
      {
        title: 'Cloud Platform (AWS IoT, Google Cloud IoT, Azure IoT)',
        details: 'Menyediakan infrastruktur skalabel untuk konektivitas perangkat, manajemen data, analitik, dan integrasi dengan layanan lain. Pilihan populer untuk solusi enterprise dan kompleks.',
      },
      {
        title: 'Server Lokal (Self-hosted)',
        details: 'Cocok untuk kebutuhan kustom, kontrol data yang lebih ketat, atau lingkungan dengan batasan jaringan. Membutuhkan setup dan pemeliharaan manual.',
      },
      {
        title: 'Broker MQTT',
        details: 'Software yang memungkinkan perangkat mengirim dan menerima pesan melalui protokol MQTT. Contoh: Mosquitto, HiveMQ, VerneMQ.',
      },
    ],
  },
  {
    category: 'Protokol Komunikasi',
    icon: '🤝',
    description: 'Bahasa yang digunakan perangkat IoT untuk saling berbicara dan berkomunikasi dengan server.',
    items: [
      {
        title: 'MQTT (Message Queuing Telemetry Transport)',
        details: 'Ringan, publish/subscribe, ideal untuk perangkat dengan sumber daya terbatas dan koneksi tidak stabil. Sangat populer untuk pengiriman data sensor.',
      },
      {
        title: 'HTTP/REST (Hypertext Transfer Protocol / Representational State Transfer)',
        details: 'Protokol web standar, mudah diimplementasikan, cocok untuk request-response sederhana atau saat volume data tidak terlalu tinggi.',
      },
      {
        title: 'CoAP (Constrained Application Protocol)',
        details: 'Mirip HTTP tetapi dirancang untuk perangkat constrained (sumber daya terbatas) dan jaringan yang lossy. Sering digunakan dalam aplikasi M2M.',
      },
      {
        title: 'AMQP (Advanced Message Queuing Protocol)',
        details: 'Protokol messaging yang lebih kompleks dan andal, cocok untuk sistem enterprise yang membutuhkan antrean pesan dan routing yang canggih.',
      },
    ],
  },
  {
    category: 'Teknologi Nirkabel',
    icon: '📡',
    description: 'Metode yang digunakan perangkat IoT untuk terhubung ke internet atau jaringan lokal tanpa kabel fisik.',
    items: [
      {
        title: 'WiFi (Wireless Fidelity)',
        details: 'Jangkauan menengah, bandwidth tinggi, cocok untuk perangkat yang butuh koneksi internet cepat dan stabil di area yang memiliki infrastruktur WiFi.',
      },
      {
        title: 'Bluetooth Low Energy (BLE)',
        details: 'Jangkauan pendek, konsumsi daya sangat rendah, ideal untuk perangkat wearable, sensor pribadi, atau komunikasi antar perangkat dekat.',
      },
      {
        title: 'LoRa/LoRaWAN (Long Range Wide Area Network)',
        details: 'Jangkauan sangat jauh (km), konsumsi daya sangat rendah, bandwidth kecil. Cocok untuk aplikasi di pedesaan, pertanian, atau kota pintar yang membutuhkan jangkauan luas.',
      },
      {
        title: 'NB-IoT (Narrowband IoT)',
        details: 'Jaringan seluler khusus IoT, konsumsi daya rendah, penetrasi sinyal baik, cocok untuk perangkat yang membutuhkan koneksi data kecil di area yang luas.',
      },
      {
        title: 'Cellular (2G/3G/4G/5G)',
        details: 'Jangkauan luas, cocok untuk aplikasi bergerak atau di lokasi terpencil tanpa WiFi. Konsumsi daya bisa lebih tinggi dibandingkan LoRa/NB-IoT.',
      },
    ],
  },
  {
    category: 'Modul Tambahan (Perluasan Fungsionalitas)',
    icon: '🔌',
    description: 'Modul pre-built yang bisa ditambahkan ke mikrokontroler untuk memberikan fungsionalitas spesifik tanpa harus merancang sirkuit dari awal.',
    items: [
      {
        title: 'Modul Sensor',
        details: 'Contoh: Sensor Suhu/Kelembaban (DHT11/DHT22), Sensor Gas (MQ-series), Sensor Jarak (Ultrasonic HC-SR04), Sensor Cahaya (LDR), Sensor Getaran, dll.',
      },
      {
        title: 'Modul Aktuator',
        details: 'Contoh: Modul Relay (untuk mengontrol listrik AC/DC), Driver Motor (untuk menggerakkan motor DC/stepper), Modul Buzzer, LED Matrix.',
      },
      {
        title: 'Modul Power Management',
        details: 'Contoh: Regulator Tegangan (step-down/step-up), Charger Baterai (TP4056), Power Bank Module.',
      },
      {
        title: 'Modul Lokasi (GPS)',
        details: 'Untuk melacak posisi geografis perangkat IoT, penting untuk aplikasi pelacakan aset atau kendaraan.',
      },
      {
        title: 'Modul Kartu SIM/GSM',
        details: 'Memungkinkan perangkat IoT berkomunikasi melalui jaringan seluler (SMS, panggilan, data internet).',
      },
    ],
  },
  {
    category: 'Komponen Elektronik Dasar',
    icon: '⚡',
    description: 'Blok bangunan fundamental yang diperlukan untuk merangkai sirkuit IoT Anda.',
    items: [
      {
        title: 'Resistor',
        details: 'Mengatur aliran arus listrik, penting untuk melindungi komponen dan membagi tegangan.',
      },
      {
        title: 'Kapasitor',
        details: 'Menyimpan muatan listrik sementara, digunakan untuk filtering, timing, dan smoothing sinyal.',
      },
      {
        title: 'LED (Light Emitting Diode)',
        details: 'Indikator visual sederhana, sering digunakan untuk debugging atau memberikan umpan balik status perangkat.',
      },
      {
        title: 'Dioda',
        details: 'Memungkinkan arus mengalir dalam satu arah, melindungi komponen dari arus balik.',
      },
      {
        title: 'Transistor',
        details: 'Berfungsi sebagai sakelar atau penguat sinyal elektronik, dasar dari semua sirkuit digital.',
      },
      {
        title: 'Breadboard & Kabel Jumper',
        details: 'Alat prototyping yang memungkinkan Anda merangkai sirkuit tanpa solder, sangat berguna untuk eksperimen dan pengujian.',
      },
    ],
  },
];

function ModulKomponen() {
  // --- SEO Meta Tags untuk Halaman Modul & Komponen IoT ---
  useEffect(() => {
    document.title = "Modul & Komponen IoT Esensial - Solusi IoT Cerdas | Panduan Lengkap";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Pelajari komponen penting sistem IoT: server, protokol (MQTT, HTTP), teknologi nirkabel (WiFi, LoRa), modul sensor, aktuator, hingga komponen dasar elektronik.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "komponen IoT, modul IoT, protokol IoT, server IoT, WiFi IoT, LoRaWAN, MQTT, sensor IoT, aktuator IoT, elektronik IoT, panduan IoT");

    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', "https://www.solusiiotcerdas.id/produk/modul-komponen"); // Ganti dengan URL halaman sebenarnya

    // Cleanup function: Akan dijalankan saat komponen di-unmount
    return () => {
      document.title = "Solusi IoT Cerdas"; // Kembalikan ke judul default aplikasi
    };
  }, []); // Dependensi kosong agar useEffect hanya dijalankan sekali (saat mount)

  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-10 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Hero Section */}
        <section className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-purple-700 dark:text-purple-400 leading-tight mb-4">
            Modul & Komponen Esensial dalam Sistem IoT
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300">
            Selami lebih dalam elemen-elemen fundamental yang membangun setiap solusi Internet of Things. Dari otak perangkat hingga bahasa yang mereka gunakan, kami akan membahas semua yang perlu Anda ketahui.
          </p>
        </section>

        {/* Konten Edukasi */}
        <div className="space-y-12">
          {iotEssentials.map((section, index) => (
            <section key={index} className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-xl transition-colors duration-300">
              <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6 flex items-center gap-3">
                <span className="text-4xl text-blue-500 dark:text-blue-300">{section.icon}</span>
                {section.category}
              </h2>
              <p className="text-lg text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">{section.description}</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {section.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
                    <h3 className="text-xl font-semibold text-blue-600 dark:text-blue-300 mb-2">{item.title}</h3>
                    <p className="text-gray-700 dark:text-gray-400 text-sm">{item.details}</p>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>

        {/* Call to Action (Opsional) */}
        <section className="mt-16 text-center">
          <h2 className="text-3xl font-bold text-blue-700 dark:text-blue-400 mb-6">Siap Merangkai Proyek IoT Anda?</h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 max-w-3xl mx-auto mb-8">
            Memahami dasar-dasar ini adalah langkah awal yang hebat. Jika Anda siap untuk mulai membangun, jelajahi produk kami di toko online atau konsultasikan ide Anda dengan kami!
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/toko" className="bg-green-500 text-white font-semibold py-3 px-8 rounded-lg shadow-lg hover:bg-green-600 transition duration-300 transform hover:scale-105">
              Lihat Produk Kami
            </Link>
            <Link to="/solusi/konsultasi" className="bg-indigo-500 text-white font-semibold py-3 px-8 rounded-lg shadow-lg hover:bg-indigo-600 transition duration-300 transform hover:scale-105">
              Konsultasikan Proyek
            </Link>
          </div>
        </section>

      </div>
    </div>
  );
}

export default ModulKomponen;